"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function fixedIntegerBitNumber(value, bit) {
    if (bit === void 0) { bit = 2; }
    if (typeof value === "number") {
        value = "" + value;
    }
    var added = [];
    for (var i = 0; i < bit - value.length; i++) {
        added.push(0);
    }
    return "" + added.join("") + value;
}
function secToStr(seconds) {
    if (seconds <= 0) {
        return "00:00:00";
    }
    return fixedIntegerBitNumber(Math.floor(seconds / 3600)) + ":" + fixedIntegerBitNumber(Math.floor((seconds % 3600) / 60)) + ":" + fixedIntegerBitNumber((seconds % 3600) % 60);
}
var TimeReduce = (function (_super) {
    __extends(TimeReduce, _super);
    function TimeReduce(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            time: 0
        };
        _this.endTimer = 0;
        return _this;
    }
    TimeReduce.prototype.componentDidMount = function () {
        var _this = this;
        var time = this.props.time;
        this.setState({
            time: time
        });
        this.endTimer = window.setInterval(function () {
            var time = _this.state.time;
            time -= 1;
            if (time >= 0) {
                _this.setState({ time: time });
            }
            else {
                window.clearInterval(_this.endTimer);
            }
        }, 1000);
    };
    TimeReduce.prototype.componentWillUnmount = function () {
        window.clearInterval(this.endTimer);
    };
    TimeReduce.prototype.render = function () {
        var className = this.props.className;
        return React.createElement("span", { className: className }, secToStr(this.state.time));
    };
    return TimeReduce;
}(React.Component));
exports.default = TimeReduce;
